module.exports = __webpack_public_path__ + "img/APP.88073e45.png";